const PercentageTypes = {
  SET_CALL_PERCENTAGE: 'SET_CALL_PERCENTAGE',
};

export default PercentageTypes;
